import { type ComponentProps, createContext, useContext } from 'react'

export interface FieldState {
  id: string
  describedBy: string | undefined
  invalid: boolean
}

export const FieldContext = createContext<FieldState | undefined>(undefined)

/** Props a control gets from its enclosing `Field` (id, aria wiring); no-op outside one. */
export function useControl(): Pick<ComponentProps<'input'>, 'id' | 'aria-describedby' | 'aria-invalid'> {
  const f = useContext(FieldContext)
  if (!f) return {}
  return { id: f.id, 'aria-describedby': f.describedBy, 'aria-invalid': f.invalid || undefined }
}
